import React, { useCallback, useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import { loadingAtom } from '../../atoms';
import { getCompanyOfCurrentUser, saveCompanyBasicInfo } from '../../utils/requestUtils';
import ActionButtonsManagerView from '../common/ActionButtonsManagerView';
import ConfirmButton from '../common/ConfirmButton';
import { brazilianStates } from '../../utils/utils';
import { searchCEP } from '../../core/Cep';
import { showAlert } from '../../core/dialog';

const newFormData = {
    name: '',
    fantasyName: '',
    cpfCnpj: '',
    inscricaoEstadual: '',
    cep: '',
    address: '',
    addressNumber: '',
    addressComplement: '',
    neighborhood: '',
    city: '',
    state: '',
    phone: '',
    email: '',
};

const CompanyBasicInfoConfiguration = () => {
    const [, setLoading] = useRecoilState(loadingAtom);
    const [formData, setFormData] = useState(newFormData);

    const loadCompany = useCallback(async () => {
        setLoading(true);
        try {
            const response = await getCompanyOfCurrentUser();
            setFormData({
                name: response?.name || '',
                fantasyName: response?.fantasyName || '',
                cpfCnpj: response?.cpfCnpj || '',
                inscricaoEstadual: response?.inscricaoEstadual || '',
                cep: response?.cep || '',
                address: response?.address || '',
                addressNumber: response?.addressNumber || '',
                addressComplement: response?.addressComplement || '',
                neighborhood: response?.neighborhood || '',
                city: response?.city || '',
                state: response?.state || '',
                phone: response?.phone || '',
                email: response?.email || '',
            });
        } catch (error) {
            console.error('Error fetching company data:', error);
        } finally {
            setLoading(false);
        }
    }, [setLoading]);

    useEffect(() => {
        loadCompany();
    }, [loadCompany]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleStateChange = (idState) => {
        setFormData((prevData) => ({
            ...prevData,
            state: idState,
        }));
    };

    async function searchCepAndFillAddressInputs() {
        let result = undefined;
        setLoading(true);
        try {
            result = await searchCEP(formData.cep);
        } finally {
            setLoading(false);
        }
        if (result != null) {
            setFormData((prevData) => ({
                ...prevData,
                address: result.street,
                neighborhood: result.neighborhood,
                city: result.city,
                state: result.state,
            }));
        } else {
            showAlert('CEP não encontrado.');
        }
    }

    function validateInputs() {
        if (!formData.name) {
            showAlert('Preencha o campo Razão Social.');
            return false;
        }
        if (!formData.fantasyName) {
            showAlert('Preencha o campo Nome Fantasia.');
            return false;
        }
        if (!formData.address) {
            showAlert('Preencha o campo endereço.');
            return false;
        }
        if (!formData.neighborhood) {
            showAlert('Preencha o campo bairro.');
            return false;
        }
        if (!formData.cep) {
            showAlert('Preencha o campo cep.');
            return false;
        }
        if (!formData.city) {
            showAlert('Preencha o campo cidade.');
            return false;
        }
        if (!formData.state) {
            showAlert('Preencha o campo estado.');
            return false;
        }
        if (!formData.phone) {
            showAlert('Preencha o campo telefone.');
            return false;
        }
        return true;
    }

    const onConfirm = async () => {
        if (!validateInputs()) {
            return;
        }
        setLoading(true);
        try {
            const { cpfCnpj, inscricaoEstadual, ...payload } = formData;
            await saveCompanyBasicInfo(payload);
            showAlert('Dados da empresa salvos com sucesso.');
        } catch (error) {
            console.error('Error saving company basic info:', error);
            showAlert('Erro ao salvar.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="app-form-page">
            <div style={{display: 'flex', alignItems: 'center'}}>
                <div className="header-label">Dados da Empresa</div>
            </div>
            <div style={{display: 'flex'}}>
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div style={{width: '180px'}}>Razão Social:</div>
                    <input type="text" style={{width: '300px'}} value={formData.name} name="name"
                           onChange={handleChange}/>
                </div>
                <div style={{marginTop: '5px', marginLeft: '5px', alignItems: 'center'}}>
                    <div style={{width: '180px'}}>Nome Fantasia:</div>
                    <input type="text" style={{width: '300px'}} value={formData.fantasyName} name="fantasyName"
                           onChange={handleChange}/>
                </div>
                <div style={{marginTop: '5px', marginLeft: '5px', alignItems: 'center'}}>
                    <div>CPF/CNPJ:</div>
                    <input style={{width: '135px'}} type="text" value={formData.cpfCnpj} name="cpfCnpj"
                           maxLength="18" disabled/>
                </div>
                <div style={{marginTop: '5px', marginLeft: '5px', alignItems: 'center'}}>
                    <div>Inscrição Estadual:</div>
                    <input style={{width: '140px'}} type="text" value={formData.inscricaoEstadual}
                           name="inscricaoEstadual" maxLength="18" disabled/>
                </div>
            </div>
            <div style={{display: 'flex'}}>
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div style={{width: '80px'}}>CEP:</div>
                    <div className="cep-field-inline">
                        <input style={{width: '80px'}} type="text" value={formData.cep} name="cep"
                               onChange={handleChange}/>
                        <button type="button" onClick={searchCepAndFillAddressInputs}>Buscar CEP</button>
                    </div>
                </div>
                <div style={{marginTop: '5px', marginLeft: '5px', alignItems: 'center'}}>
                    <div style={{width: '180px'}}>Endereço:</div>
                    <input type="text" style={{width: '297px'}} value={formData.address} name="address"
                           onChange={handleChange} autoComplete={"off"}/>
                </div>
                <div style={{marginTop: '5px', marginLeft: '5px', alignItems: 'center'}}>
                    <div style={{width: '70px'}}>Número:</div>
                    <input type="number" step="1" placeholder="0" style={{width: '70px'}}
                           value={formData.addressNumber} name="addressNumber"
                           onChange={handleChange} autoComplete={"off"}/>
                </div>
                <div style={{marginTop: '5px', marginLeft: '5px', alignItems: 'center'}}>
                    <div style={{width: '180px'}}>Complemento:</div>
                    <input type="text" style={{width: '310px'}} value={formData.addressComplement}
                           name="addressComplement"
                           onChange={handleChange} autoComplete={"off"}/>
                </div>
            </div>
            <div style={{display: 'flex'}}>
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div style={{width: '180px'}}>Bairro:</div>
                    <input type="text" style={{width: '400px'}} value={formData.neighborhood}
                           name="neighborhood" onChange={handleChange}/>
                </div>
                <div style={{marginTop: '5px', marginLeft: '5px', alignItems: 'center'}}>
                    <div style={{width: '180px'}}>Cidade:</div>
                    <input type="text" style={{width: '290px'}} value={formData.city}
                           name="city" onChange={handleChange}/>
                </div>
                <div style={{marginTop: '5px', marginLeft: '5px', alignItems: 'center'}}>
                    <div style={{width: '180px'}}>Estado:</div>
                    <select value={formData.state} onChange={(e) => handleStateChange(e.target.value)}>
                        <option value="">Selecione...</option>
                        {brazilianStates.map((estado) => (
                            <option key={estado.sigla} value={estado.sigla}>
                                {estado.sigla} - {estado.nome}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            <div style={{display: 'flex'}}>
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div style={{width: '180px'}}>Telefone:</div>
                    <input type="text" value={formData.phone} name="phone" onChange={handleChange}/>
                </div>
                <div style={{marginTop: '5px', marginLeft: '5px', alignItems: 'center'}}>
                    <div style={{width: '180px'}}>Email:</div>
                    <input type="text" style={{width: '300px'}} value={formData.email} name="email"
                           onChange={handleChange}/>
                </div>
            </div>
            <ActionButtonsManagerView>
                <ConfirmButton onClick={onConfirm} />
            </ActionButtonsManagerView>
        </div>
    );
};

export default CompanyBasicInfoConfiguration;
